import { render } from "./EditSub.vue?vue&type=template&id=968c79ea"
import script from "./EditSub.vue?vue&type=script&lang=js"
export * from "./EditSub.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__